module.exports = __webpack_public_path__ + "img/a3.7f5128e6.png";